import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-16 md:py-24 px-4 bg-slate-900" data-id="element-194">
      <div className="max-w-3xl mx-auto" data-id="element-195">
        <FadeIn data-id="element-196">
          <h2 className="text-3xl md:text-5xl font-serif italic text-amber-500 text-center mb-12 font-bold" data-id="element-197">
            EL PROBLEMA
          </h2>
        </FadeIn>

        <div className="space-y-6 text-lg md:text-xl text-slate-300 leading-relaxed font-light" data-id="element-198">
          <FadeIn delay={0.1} data-id="element-199">
            <p data-id="element-200">Son las 6 de la mañana de un sábado.</p>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-201">
            <p data-id="element-202">Salís con tu grupo de siempre.</p>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-203">
            <p data-id="element-204">Los primeros kilómetros van bien.</p>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-205">
            <p data-id="element-206">Pero entonces llega la subida.</p>
          </FadeIn>
          <FadeIn delay={0.5} data-id="element-207">
            <p data-id="element-208">Y en exactamente 90 segundos, pasa lo que siempre pasa.</p>
          </FadeIn>
          <FadeIn delay={0.6} data-id="element-209">
            <p data-id="element-210">
              Las piernas se ponen pesadas. El corazón se va a la garganta. Y la
              rueda del que va adelante empieza a alejarse...
            </p>
          </FadeIn>

          <div className="py-8 space-y-4" data-id="element-211">
            <FadeIn delay={0.7} data-id="element-212">
              <p className="text-xl text-amber-500 italic" data-id="element-213">30 centímetros.</p>
            </FadeIn>
            <FadeIn delay={0.8} data-id="element-214">
              <p className="text-xl text-amber-500 italic" data-id="element-215">Un metro.</p>
            </FadeIn>
            <FadeIn delay={0.9} data-id="element-216">
              <p className="text-xl text-amber-500 italic" data-id="element-217">Dos metros.</p>
            </FadeIn>
          </div>

          <FadeIn delay={1.0} data-id="element-218">
            <p data-id="element-219">Y ya no podés alcanzarla.</p>
          </FadeIn>
          <FadeIn delay={1.1} data-id="element-220">
            <p data-id="element-221">
              Esa sensación no es normal. No debería ser parte de cada salida.
            </p>
          </FadeIn>
          <FadeIn delay={1.2} data-id="element-222">
            <p data-id="element-223">Pero se convirtió en tu rutina.</p>
          </FadeIn>
          <FadeIn delay={1.3} data-id="element-224">
            <p data-id="element-225">Y cuando pasa, sabés exactamente lo que viene:</p>
          </FadeIn>

          <div className="py-6 pl-6 border-l-2 border-amber-500/50" data-id="element-226">
            <ul className="space-y-5" data-id="element-227">
              {['La vergüenza de llegar solo a la cima', 'Los compañeros esperándote con cara de "¿todo bien?"', 'La frustración de haber entrenado toda la semana sin resultado', 'La duda de si con tu edad ya no se puede mejorar', 'El dinero gastado en equipo que no resolvió el problema de fondo'].map((item, i) => <FadeIn key={i} delay={1.4 + i * 0.1} direction="left" data-id="element-228">
                  <li className="flex items-start gap-3" data-id="element-229">
                    <span className="text-amber-500 mt-1 font-bold" data-id="element-230">→</span>
                    <span className="text-slate-300" data-id="element-231">{item}</span>
                  </li>
                </FadeIn>)}
            </ul>
          </div>

          <FadeIn delay={2.0} data-id="element-232">
            <div className="mt-12 bg-slate-900 border border-amber-500/30 rounded-2xl p-8 md:p-10 text-center shadow-lg" data-id="element-233">
              <p className="text-2xl md:text-3xl text-white font-bold mb-6" data-id="element-234">
                ¿Cuánto te costó eso el año pasado?
              </p>
              <p className="text-slate-400 mb-8" data-id="element-235">
                En tiempo. En energía. En motivación. En ganas de seguir
                saliendo.
              </p>
              <p className="text-xl md:text-2xl text-red-500 font-bold" data-id="element-236">
                Si sos honesto... sabés que demasiado.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}